export const SEND_MESSAGE = "@@CONTACT/SEND_MESSAGE";
export const SAVE_ERROR_REPONSE_YOUR_NAME_MESSAGE =
  "@@CONTACT/SAVE_ERROR_REPONSE";

export const actionCreators = {
  sendMessage: (payload) => {
    return {
      type: SEND_MESSAGE,
      payload,
    };
  },

  saveErrorReponse: (payload) => ({
    type: SAVE_ERROR_REPONSE_YOUR_NAME_MESSAGE,
    payload,
  }),
};
